/*
 * Author: Dw
 * File Created: Thursday, 25-01-02 01:54 pm
 * Last Modified: Thursday, 25-03-06 11:10 am, by Ben Zhao
 */

import type { Logger } from '@web/utils';

// INTERNAL_ERROR 10000 通用错误
// LOGIN_STATE_ERROR  10001  登录失败 401 报错
// FORBIDDEN  10002  禁止访问非OpenAPI 以外的页面
// NOT_IN_WHITE_LIST 10003  不在UA 白名单中
// DAPI_PERMISSION_DENIED 10004 Secret不可用

export const OpenApiErrorNameMap = {
  INTERNAL_ERROR: '10000',
  LOGIN_STATE_ERROR: '10001',
  FORBIDDEN: '10002',
  NOT_IN_WHITE_LIST: '10003',
  DAPI_PERMISSION_DENIED: '10004',
} as const;

export type OPEN_API_ERROR_NAME = keyof typeof OpenApiErrorNameMap;

export type OPEN_API_ERROR_CODE =
  (typeof OpenApiErrorNameMap)[OPEN_API_ERROR_NAME];

export interface OpenApiErrorOptions {
  name: OPEN_API_ERROR_NAME;
  message?: string;
  logger?: Logger;
}

class OpenApiError extends Error {
  code?: OPEN_API_ERROR_CODE;
  name: OPEN_API_ERROR_NAME;

  constructor({ message, name, logger }: OpenApiErrorOptions) {
    super(message);

    this.name = name;
    this.code = OpenApiErrorNameMap[name];

    logger?.error('OpenAPI ERRPR', this.name, this.message);
    // 保证错误栈信息的生成
    Error.captureStackTrace(this, OpenApiError);
  }
}

export default OpenApiError;
